import script from "./AdminFinanceDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFinanceDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminFinanceDashboardView.vue?vue&type=style&index=0&id=a9b39872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b39872"]])

export default __exports__